import getDate from '@/services/data'
import axios from "axios"
export default {

  namespaced: true,

  state: {
    logs: [],
    busy: false,
    filtros: {
      data_inicio: getDate.hoje(),
      data_final: getDate.hoje(),
      status: '',
      email: '',
      id_company: '',
    }
  },

  mutations: {
    STORE_LOGS(state, result) {
      state.logs = result
    },
    SET_BUSY(state, result) {
      state.busy = result
    },

    SET_FILTROS(state, filtros) {
      state.filtros = filtros;
    },

  },

  actions: {
    listaLogs(context) {
      context.commit('SET_BUSY', true);

      axios('adm/mensagens/logs', { params: context.state.filtros} ).then(res => {
        context.commit("STORE_LOGS", res.data)
      }).finally(() => {
        context.commit('SET_BUSY', false);
      })
    }
  }

}